import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Typography, Container, Box, Button, Link, Menu } from '@mui/material';
import { Link as RLink, useNavigate } from "react-router-dom";
import { Localized } from '@fluent/react';
import { useRecoilValue } from 'recoil';
import MenuIcon from '@mui/icons-material/Menu'

import Logo from '../../assets/ucardlogotest_opt.png';
import { TelegramButton } from '../TelegramButton';
import { trafficSourceState } from '../../state';
import { getTelegramBotLink } from '../../utils/trafficSource';

export function Header() {
  const navigate = useNavigate();
  const trafficSource = useRecoilValue(trafficSourceState);
  const telegramBotLink = getTelegramBotLink(trafficSource);


  return (
    <AppBar position="sticky" sx={{
      background: '#ffffff11',
      height: { xs: '64px' },
      backdropFilter: 'blur(3px)',
      boxShadow: '0px 1px 10px 0px #00000044',
    }}>
      <Toolbar sx={{
        // backgroundColor: '#12121200'
      }}>
        {/* <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
        <MenuIcon />
      </IconButton> */}
        <Box sx={{ height: '2.5rem' }}>
          <RLink to="/" style={{ height: '100%' }}>
            <img
              src={Logo}
              style={{ height: '100%', width: 'auto' }}
              alt="UCard Logo"
            />
          </RLink>
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        
        <Button
          color="inherit"
          sx={{
            fontSize: { xs: '0.8rem', sm: '1rem' },
            display: { xs: 'none', sm: 'flex' },
          }}
          onClick={() => {
            navigate('/')
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }}>
          <Localized id="header_features">
            Возможности
          </Localized>
        </Button>
        <Button
          color="inherit"
          sx={{
            fontSize: { xs: '0.8rem', sm: '1rem' },
            display: { xs: 'none', sm: 'flex' },
          }}
          onClick={() => {
            navigate('/')
            setTimeout(() => {
              document.getElementById('pricing')?.scrollIntoView({
                behavior: "smooth",
              })
            }, 100)
          }}>
          <Localized id="header_pricing">
            Тарифы
          </Localized>
        </Button>
        {/* <Button
          color="inherit"
          sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
          onClick={() => {
            navigate('/app')
            // window.scrollTo({
            //   top: 10000,
            //   behavior: "smooth",
            // })
          }}>
          APP
        </Button> */}

        <Button
          component={RLink}
          color="inherit"
          sx={{
            ml: 1,
            fontSize: { xs: '0.8rem', sm: '1rem' },
            backgroundColor: 'rgba(0,0,0,0.25)',
          }}
          to={telegramBotLink}
          href={telegramBotLink}
          target='_blank'
          rel='noopener noreferrer'
        >
          <Localized id="header_telegram_bot">
            TELEGRAM BOT
          </Localized>
        </Button>

        {/* <TelegramButton /> */}

      </Toolbar>
    </AppBar>
  );
}

export default Header;
